// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================
    Component styles on page load
    ====================== */

.DataBlock_dataField__t4-ai {
    font-weight: 100;
}

.DataBlock_dataLabel__\\+3rmk {
    color: var(--color-text-medium);
    font-size: 12px;
    vertical-align: middle;
}

/* h1 size */
.DataBlock_xxlarge__jCCeb .DataBlock_dataField__t4-ai {
    font-size: 44px;
    line-height: 44px;
}

/* h2 size */
.DataBlock_xlarge__lROYn .DataBlock_dataField__t4-ai {
    font-size: 32px;
    line-height: 32px;
}

/* h3 size */
.DataBlock_large__ktc1- .DataBlock_dataField__t4-ai {
    font-size: 26px;
}

/* h4 size */
.DataBlock_medium__5wymy .DataBlock_dataField__t4-ai {
    font-size: 22px;
    line-height: 28px;
}

/* h5 size */
.DataBlock_small__a7f56 .DataBlock_dataField__t4-ai {
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
}

/* h6 size */
.DataBlock_xsmall__-WNU4 .DataBlock_dataField__t4-ai {
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
}

/* p size */
.DataBlock_xxsmall__kNg1R {
    margin-bottom: 11px;
}

.DataBlock_xxsmall__kNg1R .DataBlock_dataField__t4-ai {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
}

.DataBlock_hrLine__jdNEm {
    margin-top: 15px;
    margin-bottom: 7px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/DataBlock/DataBlock.module.css"],"names":[],"mappings":"AAAA;;4BAE4B;;AAE5B;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,sBAAsB;AAC1B;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["/*  ======================\n    Component styles on page load\n    ====================== */\n\n.dataField {\n    font-weight: 100;\n}\n\n.dataLabel {\n    color: var(--color-text-medium);\n    font-size: 12px;\n    vertical-align: middle;\n}\n\n/* h1 size */\n.xxlarge .dataField {\n    font-size: 44px;\n    line-height: 44px;\n}\n\n/* h2 size */\n.xlarge .dataField {\n    font-size: 32px;\n    line-height: 32px;\n}\n\n/* h3 size */\n.large .dataField {\n    font-size: 26px;\n}\n\n/* h4 size */\n.medium .dataField {\n    font-size: 22px;\n    line-height: 28px;\n}\n\n/* h5 size */\n.small .dataField {\n    font-weight: normal;\n    font-size: 18px;\n    line-height: 22px;\n}\n\n/* h6 size */\n.xsmall .dataField {\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 22px;\n}\n\n/* p size */\n.xxsmall {\n    margin-bottom: 11px;\n}\n\n.xxsmall .dataField {\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 22px;\n}\n\n.hrLine {\n    margin-top: 15px;\n    margin-bottom: 7px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataField": `DataBlock_dataField__t4-ai`,
	"dataLabel": `DataBlock_dataLabel__+3rmk`,
	"xxlarge": `DataBlock_xxlarge__jCCeb`,
	"xlarge": `DataBlock_xlarge__lROYn`,
	"large": `DataBlock_large__ktc1-`,
	"medium": `DataBlock_medium__5wymy`,
	"small": `DataBlock_small__a7f56`,
	"xsmall": `DataBlock_xsmall__-WNU4`,
	"xxsmall": `DataBlock_xxsmall__kNg1R`,
	"hrLine": `DataBlock_hrLine__jdNEm`
};
export default ___CSS_LOADER_EXPORT___;
